<template>
	<div class="contact_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<div class="image_area" :style="{'background-image':'url(' + bgimage + ')'}"></div>
		<!-- コンテンツ -->
		<div class="contents_area">
			<div class="contact_area">
				<div class="title">お問い合わせ</div>
				<div class="form_area">
					<form>
						<div class="tbl">
							<div class="tblrow">
								<div class="fieldName tblcell">お問い合わせ<div class="require">必須</div></div>
								<div class="field tblcell">
									<div class="frame">
										<select name="rev-type" v-model="contactType">
											<option value="1">資料請求</option>
											<option value="2">求人について</option>
											<option value="9">その他の問い合わせ</option>
										</select>
									</div>
								</div>
							</div>
							<div class="tblrow">
								<div class="fieldName tblcell">お名前<div class="require">必須</div></div>
								<div class="field tblcell"><input type="text" name="rev-name" v-model="name"/></div>
							</div>
							<div class="tblrow">
								<div class="fieldName tblcell">フリガナ<div class="require">必須</div></div>
								<div class="field tblcell"><input type="text" name="rev-kana" v-model="kana"/></div>
							</div>
							<div class="tblrow">
								<div class="fieldName tblcell">メールアドレス<div class="require">必須</div></div>
								<div class="field tblcell"><input type="text" name="rev-email" v-model="email"/></div>
							</div>
							<div class="tblrow">
								<div class="fieldName tblcell">会社／団体名</div>
								<div class="field tblcell"><input type="text" name="rev-companyName" v-model="companyName"/></div>
							</div>
							<div class="tblrow">
								<div class="fieldName tblcell">お問合せ内容<div class="require">必須</div></div>
								<div class="field tblcell"><textarea name="rev-textValue" v-model="textValue"></textarea></div>
							</div>
						</div>
					</form>
				</div>
				<div class="comment">
					※ご回答までにお時間をいただく場合がございます。<br>
					※受付時間外に頂いたお問い合わせにつきましては、翌営業日以降の受付となりますので、あらかじめご了承願います。<br>
					　（受付時間：平日10:00〜17:00）<br>
					※ご回答の内容は、転用、二次利用、または当該ご本人様以外に開示することを固くお断りいたします。<br>
					※Ｅメールアドレスに誤りがある場合や、システム障害が発生した場合などには、お返事できない場合がございます。<br>
					※こちらのフォームからの営業、商談、営利目的の送信はお断りしております。<br>
					<div class="form_send">
						<span class="message"><router-link :to="{ path: '/privacy' }">プライバシーポリシー</router-link>をご確認頂き、ご同意された上で送信して下さい。</span>
						<div class="button_area">
							<div class="button" :class="{ 'enableBtn':enableSendButton }" @click.stop="sendMessage">同意して送信する</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'contactPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	data() {
		return {
			bgimage: require("@/assets/images/contact_img.jpg"),
			contactType: "1",
			name: "",
			kana: "",
			email: "",
			companyName: "",
			textValue: "",
			enableSendButton: false,
			sended: false
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		},
		contactType() {
			this.checkedFields();
		},
		name() {
			this.checkedFields();
		},
		kana() {
			this.checkedFields();
		},
		email() {
			this.checkedFields();
		},
		textValue() {
			this.checkedFields();
		}
	},
	methods: {
		async sendMessage() {
			if ((this.contactType == "") || (this.name == "") || (this.kana == "") || (this.email == "") || (this.textValue == "")) {
				return;
			}

			if (this.sended) {
				return;
			}

			try {
				let param = {
					"contactType": this.contactType,
					"name": this.name,
					"kana": this.kana,
					"email": this.email,
					"company": this.companyName,
					"textValue": this.textValue
				};
				
				let request = {
					timeout: 60000,
					withCredentials: true,
					responseType: 'json',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				};
				
				let response = await Vue.$http.post('/cgi-bin/contact.py', param, request);

				this.sended = true;

				let _self = this;
				setTimeout(function(){
					_self.sended = false;
				}, 15000);

				if (response.data.status == 'ok') {
					console.log("ok");
					this.$router.push({ path: '/contact-after/' });
				} else if (response.data.status == 'err') {
					console.log(response.data.error);
					alert("送信に失敗しました。\n時間をおいて改めて送信してみて下さい。")
				}
			} catch (err) {
				console.error(err);
			}
			return;
		},
		checkedFields() {
			if ((this.contactType == "") || (this.name == "") || (this.kana == "") || (this.email == "") || (this.textValue == "")) {
				this.enableSendButton = false;
			} else {
				if (!this.checkEmail(this.email)) {
					this.enableSendButton = false;
				} else {
					this.enableSendButton = true;
				}
			}
		},
		checkEmail(val) {
			val = (val == null) ? "" : val;
			let reg = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
			return reg.test(val);
		}
	}
}
</script>

<style lang="less" scoped>
.contact_page {
	.image_area {
		width: 100%;
		height: 280px;
		background-size: cover;
		background-position: center;
	}
	
	.contents_area {
		padding: 60px 80px 20px 80px;
		
		.contact_area {
			.form_area {
				width: 100%;
				padding: 30px 40px 30px;
				
				.tbl {
					width: calc(100% - 80px);
					
					.fieldName, .field {
						padding: 16px 0;
						padding-left: 22px;
						padding-right: 22px;
					}
					
					.fieldName {
						width: 100px;
						text-align: center;
						vertical-align: middle;
						white-space: nowrap;
						background-color: #e9e9e9;
						border-bottom: 1px solid #cecece;
					}
					
					.field {
						border-bottom: 1px solid #dcdcdc;
						vertical-align: middle;
						
						input[type=text], textarea {
							width: calc(100% - 13px);
							resize: none;
							border-radius: 6px;
							border: 1px solid #cecece;
							padding: 6px;
							-webkit-appearance: none;
							appearance: none;
						}
						
						textarea {
							height: 160px;
						}
					}
					
					.tblrow {
						&:first-child .fieldName {
							border-top: 1px solid #cecece;
						}
						
						&:first-child .field {
							border-top: 1px solid #dcdcdc;
						}
					}
					
					.frame {
						padding: 0;
						border-radius: 6px;
						border: 1px solid #cecece;
						
						select {
							width: 100%;
							height: 38px;
							border-width: 0;
							background-color: transparent;
						}
					}
				}
				
				.require {
					font-size: 0.8rem;
					font-weight: bold;
					color: white;
					background-color: red;
					width: 30px;
					margin-left: auto;
					margin-right: auto;
					border-radius: 6px;
					padding: 1px 2px;
				}
				
				.form_footer {
					width: calc(100% - 80px);
				}
				
				input[type=text], textarea {
					border: none;
					outline: 0;
				}

				input[type=text]::-ms-clear, textarea::-ms-clear {
					display: none;
				}
			}
			
			.comment {
				width: calc(100% - 80px);
				padding: 10px 40px 60px;
				font-size: 0.9rem;
				
				.form_send {
					padding: 60px 0;
					width: 100%;
					
					.message {
						color: black;
						
						a {
							color: blue;
							text-decoration: none;
							font-weight: bold;
						}
					}
					
					.button_area {
						width: 100%;
						text-align: center;
						margin-top: 40px;
						
						.button {
							width: 180px;
							margin-left: auto;
							margin-right: auto;
							font-size: 1.5rem;
							border-radius: 10px;
							padding: 12px 28px;
							background-color: #cdcdcd;
							color: #ededed;
							font-weight: bold;
							cursor: default;
							border-width: 0;
						}
						
						.enableBtn {
							background-color: #71abf7;
							color: white;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	
	.title {
		font-size: 1.1rem;
		font-weight: bold;
		border-left: 8px solid #eb5f1a;
		border-bottom: 1px solid #eb5f1a;
		padding-left: 6px;
		margin-bottom: 10px;
	}
}

@media(max-width:420px) {
	.contact_page {
		.contents_area {
			padding: 60px 28px;
			
			.contact_area {
				.form_area {
					padding: 30px 0 30px;
					
					.tbl {
						width: 100%;
						
						.fieldName, .field {
							padding: 16px 0;
							padding-left: 6px;
							padding-right: 6px;
						}
						
						.fieldName {
							width: 40px;
						}
					}
				}
				
				.comment {
					padding: 10px 0 60px;
					width: 100%;
				}
			}
		}
	}
}
</style>
